// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Console = require("../Effect.Console/index.js");
var Framework_Engine = require("../Framework.Engine/index.js");
var Framework_Render_Canvas = require("../Framework.Render.Canvas/index.js");
var GameState = require("../GameState/index.js");
var Graphics_Render = require("../Graphics.Render/index.js");
var Input = require("../Input/index.js");
var UI = require("../UI/index.js");
var main = Effect_Aff.launchAff_(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Console.log("...")))(function () {
    return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(GameState.initState))(function (init) {
        return Control_Bind.bind(Effect_Aff.bindAff)(Data_Functor.map(Effect_Aff.functorAff)(Data_Maybe.fromJust())(Framework_Render_Canvas.init({
            width: UI.targetDimensions.width,
            height: UI.targetDimensions.height,
            canvasId: "canvas",
            imagePaths: UI.imagePaths
        })))(function (cv) {
            return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Graphics_Render.newRendererState(cv)))(function (ctx) {
                return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(UI.initUIState(init)))(function (uiState) {
                    var engineConfig = {
                        inputs: Input.getInputs(cv.canvas),
                        ui: UI.runUI(uiState)(init),
                        init: init,
                        step: GameState.step,
                        ctx: ctx,
                        draw: Graphics_Render.draw,
                        getAudio: UI.getAudio
                    };
                    return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Framework_Engine.runEngine(engineConfig)))(function (cancel) {
                        return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit);
                    });
                });
            });
        });
    });
}));
module.exports = {
    main: main
};
